var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-wrapper"},[_c('a-form-item',{attrs:{"label":"是否需要收集","colon":false}},[_c('a-radio-group',{directives:[{name:"decorator",rawName:"v-decorator",value:([
				"collected",
				{
					rules: [
						{
							required: true,
							message: '请选择是否需要收集',
						} ],
				} ]),expression:"[\n\t\t\t\t`collected`,\n\t\t\t\t{\n\t\t\t\t\trules: [\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\t\tmessage: '请选择是否需要收集',\n\t\t\t\t\t\t},\n\t\t\t\t\t],\n\t\t\t\t},\n\t\t\t]"}],on:{"change":_vm.onNeedChange}},_vm._l((_vm.$store.state.setting.yesNoList),function(item){return _c('a-radio',{key:item.key,attrs:{"value":item.key}},[_vm._v(" "+_vm._s(item.value)+" ")])}),1)],1),(_vm.mediateForm.getFieldValue("collected") === '1')?[_c('a-form-item',{attrs:{"label":"收集材料","colon":false}},[_c('a-textarea',{directives:[{name:"decorator",rawName:"v-decorator",value:([
					"collectData",
					{
						rules: [
							{
								required: true,
								message: '请输入',
							},
							{
								pattern: /^\S{0,200}$/,
								message: '最多200个字符（不能包含空格或换行）',
							} ],
						validateTrigger: 'blur',
					} ]),expression:"[\n\t\t\t\t\t`collectData`,\n\t\t\t\t\t{\n\t\t\t\t\t\trules: [\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\t\t\tmessage: '请输入',\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tpattern: /^\\S{0,200}$/,\n\t\t\t\t\t\t\t\tmessage: '最多200个字符（不能包含空格或换行）',\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t],\n\t\t\t\t\t\tvalidateTrigger: 'blur',\n\t\t\t\t\t},\n\t\t\t\t]"}],attrs:{"autoSize":{ minRows: 3 },"max-length":200,"placeholder":"请输入任务需要收集的原件材料，原件材料作业人员会邮寄（到付）给到案件负责人，（任务执行人可见）"}})],1),_c('a-form-item',{attrs:{"label":"邮寄地址","colon":false}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
					"mailAddress",
					{
						rules: [
							{
								required: true,
								message: '请输入邮寄地址',
							},
							{
								pattern: /^\S{0,50}$/,
								message: '最多50个字符（不能包含空格或换行）',
							} ],
					} ]),expression:"[\n\t\t\t\t\t`mailAddress`,\n\t\t\t\t\t{\n\t\t\t\t\t\trules: [\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\t\t\tmessage: '请输入邮寄地址',\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tpattern: /^\\S{0,50}$/,\n\t\t\t\t\t\t\t\tmessage: '最多50个字符（不能包含空格或换行）',\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t],\n\t\t\t\t\t},\n\t\t\t\t]"}],attrs:{"max-length":50,"placeholder":"请输入邮寄地址"}})],1),_c('a-row',{staticClass:"mail-info",attrs:{"gutter":8}},[_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"收件人","colon":false,"wrapper-col":{ span: 24 }}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
							"mailReceivor",
							{
								validateTrigger: 'blur',
								rules: [
									{
										required: true,
										message: '请输入收件人姓名',
									},
									{
										pattern: /^\S{0,50}$/,
										message: '最多50个字符（不能包含空格或换行）',
									} ],
							} ]),expression:"[\n\t\t\t\t\t\t\t`mailReceivor`,\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tvalidateTrigger: 'blur',\n\t\t\t\t\t\t\t\trules: [\n\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\t\t\t\t\tmessage: '请输入收件人姓名',\n\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\tpattern: /^\\S{0,50}$/,\n\t\t\t\t\t\t\t\t\t\tmessage: '最多50个字符（不能包含空格或换行）',\n\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t],\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t]"}],attrs:{"max-length":50,"placeholder":"请输入收件人姓名","disabled":_vm.recipientSameWithPublisher}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"收件人电话","colon":false,"label-col":{ span: 12 },"wrapper-col":{ span: 24 }}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
							"mailReceivorPhone",
							{
								validateTrigger: 'blur',
								rules: [
									{
										required: true,
										message: '请输入收件人电话',
									},
									{
										pattern: /^1[3456789]\d{9}$/,
										message: '请输入正确的11位手机号码',
									} ],
							} ]),expression:"[\n\t\t\t\t\t\t\t`mailReceivorPhone`,\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tvalidateTrigger: 'blur',\n\t\t\t\t\t\t\t\trules: [\n\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\t\t\t\t\tmessage: '请输入收件人电话',\n\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\tpattern: /^1[3456789]\\d{9}$/,\n\t\t\t\t\t\t\t\t\t\tmessage: '请输入正确的11位手机号码',\n\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t],\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t]"}],attrs:{"max-length":11,"placeholder":"请输入收件人电话","disabled":_vm.recipientSameWithPublisher}})],1),_c('a-checkbox',{staticClass:"float-right",attrs:{"checked":_vm.recipientSameWithPublisher},on:{"change":_vm.onRecipientSameChange}},[_vm._v("同任务发布人 ")])],1)],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }